"use client";

import { memo } from "react";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "@/components/ui/card";
import { SkeletonCardProps } from "./types";

// Componente de skeleton memoizado
export const SkeletonCard = memo(({ index }: SkeletonCardProps) => (
  <Card
    key={`skeleton-${index}`}
    className="max-w-sm bg-[#fdfdfd] w-full rounded-2xl border-[#dee1e7] border-2 mx-auto overflow-hidden h-[420px] md:h-[450px] xl:h-[490px] shadow-2xl z-[9999] relative"
  >
    {/* Imagen con efecto shimmer */}
    <div className="relative h-48 md:h-56 xl:h-64 overflow-hidden p-[.4rem] rounded-xl">
      <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-shimmer rounded-xl"
        style={{ backgroundSize: '200% 100%' }}></div>
    </div>

    {/* Header con nombre */}
    <CardHeader className="py-2 md:py-3 gap-0 flex flex-row justify-between items-center relative">
      <div className="flex flex-col gap-1 md:gap-2 w-full relative">
        <div className="flex items-center gap-2">
          <div className="h-6 md:h-8 w-3/4 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-shimmer rounded"
            style={{ backgroundSize: '200% 100%' }}></div>
          <div className="h-4 w-4 md:h-5 md:w-5 rounded-full bg-gradient-to-r from-gray-300 via-gray-200 to-gray-300 animate-shimmer"
            style={{ backgroundSize: '200% 100%' }}></div>
        </div>
        <div className="h-4 md:h-5 w-full bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-shimmer rounded"
          style={{ backgroundSize: '200% 100%' }}></div>
      </div>
    </CardHeader>

    {/* Contenido */}
    <CardContent className="space-y-2">
      <div className="flex items-center justify-between">
        <div className="h-4 md:h-5 w-1/3 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-shimmer rounded"
          style={{ backgroundSize: '200% 100%' }}></div>
        <div className="h-4 md:h-5 w-1/2 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-shimmer rounded"
          style={{ backgroundSize: '200% 100%' }}></div>
      </div>

      <hr className="border-t border-[#3088ec1e]" />
    </CardContent>

    {/* Footer con botón */}
    <CardFooter className="flex justify-center items-center w-full absolute bottom-0">
      <div className="w-full h-8 md:h-10 bg-gradient-to-r from-blue-400 via-blue-300 to-blue-400 animate-shimmer rounded-md"
        style={{ backgroundSize: '200% 100%' }}></div>
    </CardFooter>
  </Card>
));

SkeletonCard.displayName = 'SkeletonCard'; 